<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px" />
                    <div class="row">
                        <div class="col-12 text-right mb-1">
                            <b-button size="sm" class="btn btn-success" @click="create">Create trade</b-button>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Name</th>
                                    <th>Max batch</th>
                                    <th>Duration days</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in trades" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.desc }}</td>
                                    <td>{{ item.max_batches }}</td>
                                    <td>{{ item.duration_days }}</td>
                                    <td>
                                        <a href="javascript:void(0);" class="action-icon" title="Edit"
                                            @click.prevent="edit(item.id)">
                                            <i class="mdi mdi-square-edit-outline editButton"></i>
                                        </a>

                                        <a href="javascript:void(0);" class="action-icon" title="Delete"
                                            @click.prevent="deleteData(item.id)">
                                            <i class="mdi mdi-delete deleteButton"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h5 v-if="trades.length === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
        <add-modal :data="data" :btn_edit="btn_edit" @getData="getData"></add-modal>
    </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

import AddModal from "./modal/add-modal.vue";

export default {
    page: {
        title: "Trades List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, AddModal },
    data() {
        return {
            title: "Trades List",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Trades List",
                    active: true
                }
            ],
            trades: [],
            roles: [],
            user_id: "",
            btn_edit: false,
            data: {},
        };
    },

    mounted() {
        this.getData();
    },
    methods: {
        create() {
            this.data = {}
            this.btn_edit = false
            this.$bvModal.show('bv-modal-example')
        },
        getData() {
            http.get("api/trades/all").then(response => {
                if (!response.error) {
                    this.trades = response.data
                }
            });
        },
        edit(id) {
            http.get("api/trades/edit/" + id).then(response => {
                if (!response.error) {
                    this.data = response.data
                    this.btn_edit = true
                    this.$bvModal.show('bv-modal-example')
                }
            });
        },
        deleteData(id) {
            if (confirm("Are you sure?")) {
                http.get("api/trades/delete/" + id).then(response => {
                    if (!response.error) {
                        this.$bvToast.toast('Trade is deleted', {
                            title: "Success",
                            autoHideDelay: 5000,
                            variant: "success"
                        });
                        this.getData()
                    }
                });
            }
        }
    },
};
</script>
